import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card } from '@node-space/ui-components'
import { EarnSummaryItem } from './EarnSummaryItem'

export interface EarnAssetEarningsSummaryProps {
  myLifetimeEarnings: string
  customerEarningsReceived: string
  distributedEarningsToCustomers: string
}

export const EarnAssetEarningsSummary = ({
  myLifetimeEarnings,
  customerEarningsReceived,
  distributedEarningsToCustomers,
}: EarnAssetEarningsSummaryProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full borderRadius={12} testId="earn-asset-earnings-summary">
      <Box flex gap={24} align="center" className="max-lg:flex-col max-lg:items-start">
        <EarnSummaryItem label={t('earn.myLifetimeEarnings')} value={myLifetimeEarnings} />
        <EarnSummaryItem
          label={t('earn.customerEarningsIReceive')}
          value={customerEarningsReceived}
        />
        <EarnSummaryItem
          label={t('earn.distributedEarningsToCustomersLabel')}
          value={distributedEarningsToCustomers}
          tooltipContent={t('earn.distributedEarningsToCustomersTooltip')}
        />
      </Box>
    </Card>
  )
}
